import {takeEvery,all,put,select,call} from 'redux-saga/effects';
import * as actions from './actions';
import * as selectors from './selectors';
import * as commodityReportApi from '../api/commodityReportApi'
import { searchToFilters } from '../common/urlUtils';
import actionFactory from '../webcommon/header/filterheader/actions';
import * as filterHeaderSelectors from '../webcommon/header/filterheader/selectors';
import fileDownload from 'js-file-download';



export const filterHeaderActions = actionFactory('CommodityReportUpload');

export function* uploadFileConnected(action){
    try {
        const initialised = yield select(selectors.getMonthlyUploadInitialised);        
        if (!initialised) {
            yield put(actions.setMonthlyUploadLoading(true));
            const filterDefinitions = yield select(selectors.getFilterDefinitions);
            yield put(filterHeaderActions.setFilterDefinitions(filterDefinitions));
            const defaultFilters = yield select(selectors.getDefaultFilters);
            yield put(filterHeaderActions.setDefaultFilters(defaultFilters));
            if (action.search === '') {
                yield put(filterHeaderActions.resetFilters());
            } else {
                const filters = searchToFilters(action.search, filterDefinitions, defaultFilters);
                yield put(filterHeaderActions.setFilters(filters));
            }
            yield put(actions.getMonthlyFileUploads())
            yield put(actions.setMonthlyUploadInitialised(true));
            yield call(filterChanged, action);
        }
    } finally {
        yield put(actions.setMonthlyUploadLoading(false));
    }
}

export function* exportConnected(action){
    try {
        const initialised = yield (select(selectors.getExportInitialised));
        if (!initialised) {
            yield put(actions.setMonthlyUploadLoading(true));
            yield put(actions.getCommodityReports())
            yield put(actions.setExportInitialised(true));
        }
    } finally {
        yield put(actions.setExportLoading(false));
    }
}

export function* dailyFilesConnected(action){
    try {
        const initialised = yield (select(selectors.getDailyFilesInitialised));
        if (!initialised) {
            yield put(actions.setDailyFilesLoading(true));
            yield put(actions.getDailyFiles())
            yield put(actions.setDailyFilesInitialised(true));
        }
    } finally {
        yield put(actions.setDailyFilesLoading(false));
    }
}

export function* filterChanged(action) {
    const initialised = yield select(selectors.getMonthlyUploadInitialised);
    if (initialised) {
        const currentlyOpenFilter = yield (select(filterHeaderSelectors.getCurrentlyOpenFilter, 'CommodityReportUpload'));
        if (!currentlyOpenFilter) {
            const filters = yield select(filterHeaderSelectors.getFilters, 'CommodityReportUpload');
            yield put(actions.setRunDate(filters[0].value.from));                        
        }
    }
} 

export function* uploadMonthlyFile(api, action) {
    try {
        const requestObject = {
            runDate: action.data.date,
            rows: action.data.rows
        };
        const result = yield call(api.uploadFile, requestObject)    
        console.log('calling upload file success')    
        yield put(actions.uploadMonthlyFileSuccess(result))
        console.log('called upload file success')
    } catch (error) {
        yield put(actions.uploadMonthlyFileFailed('Failed to upload Monthly file!'));
    }
}

export function* getMonthlyFileUploads(api, action) {
    try {
        const result = yield call(api.getFileUploads)
        yield put(actions.getMonthlyFileUploadsSuccess(result))
    } catch (error) {
        yield put(actions.getMonthlyFileUploadsFailed('Failed to retrieve files from Database'));
    }
}

export function* getDailyFiles(api, action) {
    try {
        const result = yield call(api.getDailyFiles)
        yield put(actions.getDailyFilesSuccess(result))
    } catch (error) {
        yield put(actions.getDailyFilesFailed('Failed to retrieve files from Database'));
    }
}

export function* getCommodityReports(api, action) {
    try {
        const result = yield call(api.getCommodityReportsFromCloud)
        console.log(result)
        yield put(actions.getCommodityReportsSuccess(result))
    } catch (error) {
        yield put(actions.getCommodityReportsFailed('Failed to retrieve reports from Database'));
    }
}

export function* validateMonthlyFile(api, action) {
    try {
        console.log('calling validateFile...')
        const result = yield call(api.validateFile, action.file)
        console.log(result)
        yield put(actions.validateMonthlyFileSuccess(result))
    } catch (error) {
        yield put(actions.validateMonthlyFileFailed('Validation of monthly file failed'));
    }
}

export function* exportReports(api , action) {   
   try{
    const result = yield call(api.exportCommodityReport, action.ids)
    console.log(result) 
    yield put(actions.exportReportsSuccess(result))
} catch (e){
    console.error("Failed to retrieve report")
    yield put(actions.exportReportsFailed("Failed to retrieve report"))
} 
   
}

export function* createBrowserDownload(fd, action) {
    console.log(action)
    yield call(fd, action.downloadFile.data, action.downloadFile.filename);
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.COMMODITY_REPORT_MONTHLY_UPLOAD_LOADED, uploadFileConnected),
        takeEvery(actions.COMMODITY_REPORT_EXPORT_LOADED, exportConnected),
        takeEvery(actions.DAILY_FILES_LOADED, dailyFilesConnected),
        takeEvery(actions.UPLOAD_MONTHLY_FILE, uploadMonthlyFile, commodityReportApi),
        takeEvery([actions.GET_MONTHLY_FILE_UPLOADS, actions.REFRESH_MONTHLY_UPLOAD_DATA], getMonthlyFileUploads, commodityReportApi),
        takeEvery([actions.GET_COMMODITY_REPORTS, actions.REFRESH_REPORT_DATA], getCommodityReports, commodityReportApi),
        takeEvery([filterHeaderActions.UPDATE_FILTER,filterHeaderActions.REMOVE_FILTER,filterHeaderActions.RESET_FILTERS], filterChanged),
        takeEvery(actions.EXPORT_COMMODITY_REPORTS, exportReports, commodityReportApi),
        takeEvery(actions.EXPORT_COMMODITY_REPORT_SUCCESS, createBrowserDownload, fileDownload),
        takeEvery(actions.VALIDATE_MONTHLY_FILE, validateMonthlyFile, commodityReportApi),
        takeEvery([actions.GET_DAILY_FILES, actions.REFRESH_DAILY_FILES], getDailyFiles, commodityReportApi),

    ]);
}